import React from 'react'

import { CaretDownOutlined, DownOutlined } from '@ant-design/icons'
import { Dropdown, Menu } from 'antd'

import { navbarTelemetry } from '~/telemetry'
import envConfig from '~/utils/env-config'

// spec: https://pingcap.feishu.cn/wiki/wikcnk9QI68EnsHqohxeTRTsRzf - Add quick links
const { opsPortal, loki, metricTool } = envConfig.quickLinks
const links = [
  {
    name: 'Ops Portal',
    note: 'for operations',
    href: opsPortal
  },
  {
    name: 'Metrics tool',
    note: '',
    href: metricTool
  },
  {
    name: 'Grafana',
    note: '',
    href: '/grafana/' // don't ignore the last slash
  },
  {
    name: 'Loki',
    note: 'for logs',
    href: loki
  }
]

const menu = (
  <Menu>
    {links.map((l, idx) => (
      <Menu.Item key={idx}>
        <a
          target='_blank'
          href={l.href}
          onClick={() => navbarTelemetry.clickQuickLinks(`${l.name} ${l.note}`)}
        >
          <span
            className='font-bold'
            style={{ color: 'var(--cc-primary-color)' }}
          >
            {l.name}
          </span>{' '}
          ({l.note})
        </a>
      </Menu.Item>
    ))}
  </Menu>
)

const QuickLinks: React.FC<{ theme?: 'light' | 'dark' }> = ({
  theme = 'light'
}) => {
  return (
    <Dropdown overlay={menu} placement='bottomRight' trigger={['click']} arrow>
      <a onClick={() => navbarTelemetry.clickQuickLinks('')}>
        {theme === 'light' ? (
          <>
            <span className='mr-2'>Quick Links</span>
            <DownOutlined />
          </>
        ) : (
          <>
            <span className='text-white mr-2'>Quick Links</span>
            <CaretDownOutlined className='text-white' />
          </>
        )}
      </a>
    </Dropdown>
  )
}

export default QuickLinks
